(() => {
  if (window.BodenpulseSampleLimits) return;
  const configElement = document.getElementById('BodenpulseSampleLimitsConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const maxSamples = Number(config.maxSamples);
  let pendingCheck = null;
  let hasSamples = config.hasSamples;
  let lastMessage = '';
  const approvedForms = new WeakSet();
  const pendingForms = new WeakSet();

  function isSample(item) {
    return String(item.sku || '').toUpperCase().startsWith('BP-MU-') ||
      String(item.handle || '').endsWith('-kostenloses-muster') ||
      String(item.properties?._bp_sample || '') === 'true';
  }

  function plan(cart) {
    const updates = {};
    const seen = new Set();
    for (const item of cart.items) {
      if (!isSample(item)) continue;
      const identity = String(item.product_id || item.variant_id || item.id);
      if (seen.has(identity)) {
        updates[item.key] = 0;
      } else {
        seen.add(identity);
        if (Number(item.quantity) !== 1) updates[item.key] = 1;
      }
    }
    return { updates, sampleCount: seen.size };
  }

  function showMessage(message = '') {
    lastMessage = message;
    document.querySelectorAll('[data-bp-sample-limit-message]').forEach((element) => {
      element.textContent = message;
      element.hidden = !message;
    });
  }

  function setBlocked(blocked) {
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((button) => {
      if (blocked && !button.disabled) {
        button.dataset.bpSampleBlocked = 'true';
        button.disabled = true;
      } else if (!blocked && button.dataset.bpSampleBlocked === 'true') {
        delete button.dataset.bpSampleBlocked;
        button.disabled = false;
      }
    });
  }

  async function readCart() {
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' }, cache: 'no-store'
    });
    if (!response.ok) throw new Error(config.strings.checkError);
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error(config.strings.checkError);
    return cart;
  }

  async function refreshCart(cart) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      await publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'bodenpulse-sample-limits', cartData: cart
      });
    }
    if (cart.sections) {
      for (const id of ['cart-icon-bubble', 'cart-live-region-text']) {
        const target = document.getElementById(id);
        if (!target || !cart.sections[id]) continue;
        const html = new DOMParser().parseFromString(cart.sections[id], 'text/html');
        const content = html.querySelector('.shopify-section');
        if (content) target.innerHTML = content.innerHTML;
      }
    }
  }

  async function checkCart() {
    let cart = await readCart();
    let corrected = false;
    for (let attempt = 0; attempt < 2; attempt += 1) {
      const { updates } = plan(cart);
      if (!Object.keys(updates).length) break;
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: ['cart-icon-bubble', 'cart-live-region-text'] })
      });
      cart = await response.json();
      if (!response.ok || !Array.isArray(cart.items)) throw new Error(config.strings.checkError);
      corrected = true;
    }
    const state = plan(cart);
    if (Object.keys(state.updates).length) throw new Error(config.strings.checkError);
    hasSamples = state.sampleCount > 0;
    if (corrected) await refreshCart(cart);
    document.querySelectorAll('[data-bp-sample-line="true"]').forEach((input) => {
      input.value = '1';
      input.setAttribute('value', '1');
    });
    const blocked = state.sampleCount > maxSamples;
    setBlocked(blocked);
    showMessage(blocked ? config.strings.tooMany : corrected ? config.strings.corrected : '');
    if (blocked) throw new Error(config.strings.tooMany);
    return cart;
  }

  function ensureCart() {
    if (!pendingCheck) {
      pendingCheck = checkCart().finally(() => { pendingCheck = null; });
    }
    return pendingCheck;
  }

  async function prepareAddition(variantId, productId) {
    const cart = await ensureCart();
    if (cart.items.some((item) => isSample(item) &&
      (String(item.variant_id) === String(variantId) || String(item.product_id) === String(productId)))) {
      throw new Error(config.strings.alreadyAdded);
    }
    if (plan(cart).sampleCount >= maxSamples) throw new Error(config.strings.tooMany);
    return cart;
  }

  window.BodenpulseSampleLimits = { isSample, plan, ensureCart, prepareAddition, strings: config.strings };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (approvedForms.has(form)) {
      approvedForms.delete(form);
      return;
    }
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout' ||
      (!hasSamples && !document.querySelector('[data-bp-sample-line="true"]'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pendingForms.has(form)) return;
    pendingForms.add(form);
    ensureCart().then(() => {
      const currentForm = form.isConnected ? form : document.getElementById(form.id);
      if (!(currentForm instanceof HTMLFormElement)) throw new Error(config.strings.checkError);
      const currentSubmitter = submitter?.isConnected && submitter.form === currentForm
        ? submitter
        : document.querySelector(`[name="checkout"][form="${CSS.escape(currentForm.id)}"]`) ||
          currentForm.querySelector('[name="checkout"]');
      if (!currentSubmitter || currentSubmitter.disabled) throw new Error(config.strings.checkError);
      approvedForms.add(currentForm);
      currentForm.requestSubmit(currentSubmitter);
    }).catch((error) => {
      showMessage(error.message || config.strings.checkError);
    }).finally(() => {
      pendingForms.delete(form);
    });
  }, true);

  function start() {
    if (hasSamples) ensureCart().catch((error) => showMessage(error.message));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'bodenpulse-sample-limits') return;
        const items = event.cartData?.items || [event.cartData || {}];
        if (hasSamples || items.some(isSample) || document.querySelector('[data-bp-sample-line="true"]')) {
          return ensureCart().catch((error) => showMessage(error.message));
        }
      });
    }
    document.addEventListener('bodenpulse:sample-cart-refresh', () => {
      ensureCart().catch((error) => showMessage(error.message));
    });
    document.addEventListener('shopify:section:load', () => showMessage(lastMessage));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
